// dist/nft-shot/nft【API】のレスポンスをモデル化したもの

export class Attribute {
    readonly traitType: string;
    readonly value: string;
    constructor(json: any) {
        this.traitType = json[`traitType`];
        this.value = json[`value`];
    }
}



export class MetaData {
    readonly animationUrl:string;
    readonly attributes:Attribute[];
    readonly description:string;
    readonly externalUrl:string;
    readonly image:string;
    readonly name:string;
    constructor(json:any) {
        this.animationUrl = json[`animationUrl`];
        this.description = json[`description`];
        this.externalUrl = json[`externalUrl`];
        this.image = json[`image`];
        this.name = json[`name`];
        this.attributes = json['attributes'] ? json['attributes'].map((attributeJson: any) => new Attribute(attributeJson)) : [];
    }
}

class NftReceivingImage {
    readonly url:string;
    readonly isBlurred:boolean;
    constructor(json:any) {
        this.url = json[`url`];
        this.isBlurred = json[`isBlurred`];
    }
}

export class DistPageConfig {
    readonly insertTweetText:string;
    readonly isGachaMovie:string;
    readonly isGetNFTagainButton:string;
    readonly isTweetButton:string;
    readonly lang:string;
    meta:string;
    readonly nftReceivingMovieUrl:string;
    readonly nftReceivingImage:NftReceivingImage;
    readonly walletTypeArray:string[];
    readonly web3layerUrl:string;
    readonly backgroundImage:string;

    constructor(json:any) {
        this.insertTweetText = json[`insertTweetText`];
        this.isGachaMovie = json[`isGachaMovie`];
        this.isGetNFTagainButton = json[`isGetNFTagainButton`];
        this.isTweetButton = json[`isTweetButton`];
        this.lang = json[`lang`];
        this.meta = json[`meta`]
        this.nftReceivingMovieUrl = json[`nftReceivingMovieUrl`];
        this.nftReceivingImage = new NftReceivingImage(json[`nftReceivingImage`]);
        this.walletTypeArray = json[`walletTypeArray`];
        this.web3layerUrl = json[`web3layerUrl`];
        this.backgroundImage = json[`backgroundImage`];
    }
}

export class Contract {
    readonly address:string;
    constructor(json:any) {
        this.address = json[`address`];
    }
}

export class Chain {
    readonly id:number;
    constructor(json:any) {
        this.id = json[`id`];
    }
}

export class NFTInfoModel {
    readonly chain:Chain;
    readonly contract:Contract;
    readonly distPageConfig:DistPageConfig;
    readonly metaData:MetaData;
    readonly mitable:boolean;

    constructor(json:any) {
        this.chain = new Chain(json[`chain`]);
        this.contract = new Contract(json[`contract`]);
        this.distPageConfig = new DistPageConfig(json[`distPageConfig`]);
        this.metaData = new MetaData(json[`metaData`]);
        this.mitable = json[`mintable`];
    }
}